import { render, staticRenderFns } from "./right_1.vue?vue&type=template&id=1879886e&scoped=true&"
import script from "./right_1.vue?vue&type=script&lang=js&"
export * from "./right_1.vue?vue&type=script&lang=js&"
import style0 from "./right_1.vue?vue&type=style&index=0&id=1879886e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1879886e",
  null
  
)

export default component.exports